export const articleTitleContainerCss = {
  marginBottom: "64px",
};
